import { Avatar, Button, Card, Checkbox, Flex, Space, Switch, theme, Typography, Input, Divider, Tooltip } from 'antd'
import { ExportOutlined, LockOutlined, MoreOutlined, QuestionCircleOutlined, UpSquareOutlined } from '@ant-design/icons'
import { categories, useChannels } from '@entities/channel'
import React, { useMemo, useState } from 'react'
import useMobileView from '@shared/hooks/isMobile'
import { usePosts } from '@entities/post'
import { InternetRecourceType } from '@entities/channel/model/types'

const { Title, Text, Link } = Typography

export const TopSideHeader = ({ title }: { title: string }) => {
    const [checkedButton, setCheckedButton] = useState(1)
    const isMobile = useMobileView()
    const {
        token: {
            magenta,
            colorWhite,
            red,
            volcano,
            orange,
            gold,
            lime,
            green,
            cyan,
            blue,
            geekblue,
            purple,
            colorTextDescription,
            colorPrimary
        }
    } = theme.useToken()

    const customColors = useMemo(
        () => [magenta, red, volcano, orange, gold, lime, green, cyan, blue, geekblue, purple],
        [blue, cyan, geekblue, gold, green, lime, magenta, orange, purple, red, volcano]
    )

    const {
        actions: { editChannel, getEmployees, updateInfo },
        channelDetails
    } = useChannels()

    const {
        actions: { createType, deleteType }
    } = usePosts({ channelId: channelDetails?.id })

    const isChannel = useMemo(() => channelDetails?.type === InternetRecourceType.channel, [channelDetails?.type])

    const onChangeButton = (btn: number) => {
        setCheckedButton(btn)
    }
    if (isMobile) {
        return (
            <Card style={{ backgroundColor: '#fff' }} bodyStyle={{ padding: '15px' }}>
                <Flex align={'center'} gap={45}>
                    <Switch style={{ width: 100 }} checkedChildren="Фикс" unCheckedChildren="CPM" />
                    <Input placeholder="Введите цену 0 Р" />
                </Flex>
                <Divider style={{ margin: '10px 0' }} />
                <Flex gap={'small'} align={'center'} justify={'space-between'}>
                    <Checkbox style={{ color: colorPrimary }}>
                        Предложение для уникального партнера Не активно/Активно
                    </Checkbox>
                    <Tooltip title="Оплата будет отправлена на привязанную банковскую карту сразу после завершения сделки. Временно доступно только для карт РФ и РБ банков. Для успешной выплаты ваш профиль должен быть активирован через банк.">
                        <QuestionCircleOutlined style={{ color: colorPrimary, cursor: 'help' }} />
                    </Tooltip>
                    <Button style={{ width: 50 }} type="primary" icon={<UpSquareOutlined />} />
                </Flex>
                <Divider style={{ margin: '10px 0' }} />
                <Button
                    type={'primary'}
                    style={{ fontWeight: 500, width: '100%', height: 40 }}
                    iconPosition={'end'}
                    icon={<LockOutlined style={{ fontSize: 20 }} />}
                >
                    Сохранить условия
                </Button>
            </Card>
        )
    }
    return (
        <>
            {/* Заголовок страницы */}
            <Flex justify="space-between" align="center" style={{ marginBottom: '16px' }}>
                <Title style={{ marginTop: 0 }} level={3}>
                    {title}
                </Title>
            </Flex>
            <Flex justify={'space-between'}>
                {/* Данные канала */}
                <Space size={20} align="start" style={{ marginBottom: 50 }}>
                    <Avatar
                        shape="circle"
                        size={100}
                        src={isChannel ? channelDetails?.photoUrl : `${channelDetails?.url}/favicon.ico`}
                    />
                    <Flex vertical={true} gap={6}>
                        <Title
                            level={4}
                            style={{ margin: 0, cursor: 'pointer' }}
                            onClick={() =>
                                isChannel
                                    ? window.open(`https://t.me/${channelDetails?.username}`)
                                    : window.open(`${channelDetails?.url}`)
                            }
                        >
                            <Space>
                                {channelDetails?.name}
                                <ExportOutlined />
                            </Space>
                        </Title>

                        {isChannel ? (
                            <>
                                <Text italic>@{channelDetails?.username}</Text>
                                <Space size={2}>
                                    <Text>{channelDetails?.timezone}</Text>
                                    <Button
                                        type="text"
                                        style={{ padding: '4px' }}
                                        onClick={() => setIsEditChannelModalOpen(true)}
                                    >
                                        <MoreOutlined />
                                    </Button>
                                </Space>
                                <Text>{channelDetails?.membersCount} подписчиков</Text>
                                <Text>{categories.find((c) => c.value === channelDetails?.category)?.label}</Text>
                            </>
                        ) : (
                            <></>
                        )}
                    </Flex>
                </Space>
                <Flex vertical gap={39}>
                    <Flex vertical align={'center'}>
                        <Text style={{ fontSize: 16 }}>
                            <strong>Подписка: активна</strong>
                        </Text>
                        <Text>Итекает через 23 дня</Text>
                    </Flex>
                    <Flex vertical>
                        <Flex gap={7}>
                            <Button
                                style={{
                                    borderColor: checkedButton === 1 ? colorPrimary : 'gray',
                                    color: checkedButton === 1 ? colorPrimary : 'gray'
                                }}
                                onClick={() => onChangeButton(1)}
                            >
                                СРМ
                            </Button>
                            <Button
                                style={{
                                    borderColor: checkedButton === 2 ? colorPrimary : 'gray',
                                    color: checkedButton === 2 ? colorPrimary : 'gray'
                                }}
                                onClick={() => onChangeButton(2)}
                            >
                                Фикс
                            </Button>
                            <Button
                                style={{
                                    borderColor: '#FFAA00',
                                    color: '#FFAA00',
                                    width: 170,
                                    fontWeight: 'bold',
                                    fontSize: 17
                                }}
                            >
                                0 Р
                            </Button>
                            <Button type="primary" icon={<LockOutlined />} iconPosition={'end'}>
                                Сохранить
                            </Button>
                            <Button type="primary" disabled={true}>
                                Опубликовать
                            </Button>
                        </Flex>
                        <Flex justify={'end'}>
                            <Checkbox style={{ marginTop: 10, color: colorPrimary }}>
                                Частное предложение 1 пользолвателю
                            </Checkbox>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </>
    )
}
